export const PICKER_PANEL_SEARCH_ICON = 'search-sm';

export const PICKER_PANEL_PLACEMENT = {
    // Opens below its anchor.
    BOTTOM: 'bottom',
    // Opens above its anchor.
    TOP: 'top',
};

export const PICKER_PANEL_PLACEMENTS = Object.values(PICKER_PANEL_PLACEMENT);
